import { IntentType } from '@40seas/entities/intents';
import jwt_decode from 'jwt-decode';
import { convertStringToEnumValue } from './layoutStrategyManager';
import { DashboardModalConfig, LayoutStrategyProvider, LayoutStrategyProviderParams } from './layoutStrategyProvider';
import { GUEST_PORTAL_INTENTS } from './consts';

export class SignupModalStrategyProvider implements LayoutStrategyProvider {
    constructor(private readonly params: LayoutStrategyProviderParams) {}

    shouldApply = (): boolean => {
        const { user, urlToken } = this.params;

        if (urlToken) {
            const decodedData = jwt_decode<{ intentType: string; guestPortal: boolean }>(urlToken || '');
            const intentType = convertStringToEnumValue(decodedData.intentType);

            const isGuestPortal = intentType ? GUEST_PORTAL_INTENTS.includes(intentType) : false;

            if (isGuestPortal) {
                return false;
            }
        }

        return !user?.organizations?.length || !user.emailVerified;
    };

    openModal = (): DashboardModalConfig => {
        const { guestToken } = this.params;
        if (!guestToken) {
            return { intentType: IntentType.Signup, token: '' };
        }

        const intent = jwt_decode<{ intentType: string }>(guestToken);
        const intentType = convertStringToEnumValue(intent.intentType) || IntentType.Signup;

        return { intentType, token: guestToken };
    };
}
